import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular/standalone";
import { IonHeader, IonToolbar, IonTitle, IonContent, IonList, IonItem, IonLabel, IonInput } from "@ionic/angular/standalone";
import {Router} from '@angular/router';
import {DisplayService} from '@qid/core';
import {CreateIndustryDto} from '../../dto/create-industry.dto';
import {Industry} from '../../model/industry.model';
import {IndustryService} from '../../services/industry.service';
import {RestResponse} from "../../../../../interface/RestInterface";
import { FormsModule } from '@angular/forms';
import { SexyModule } from '@qid/sexy';
import { SuperButtonComponent, PageActionComponent } from '@qid/super';


@Component({
  selector: 'app-create-industry',
  templateUrl: './edit-industry.page.html',
  styleUrls: ['./edit-industry.page.scss'],
  standalone: true,
  imports: [
    FormsModule,
    SexyModule,
    SuperButtonComponent,
    PageActionComponent,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    IonInput
  ]
})
export class EditIndustryPage implements OnInit {
  public industry: Industry;

  @Input() parentIndustry: Industry = null;

  public dto: CreateIndustryDto = new CreateIndustryDto();
  public id: any = null;

  constructor(private industryService: IndustryService,
              private modalController: ModalController,
              private displayService: DisplayService,
              private router: Router,
  ) {
  }

  ngOnInit() {
    this.getIndustryID();

  }

  async getIndustryID() {
    const route = this.router.url;
    const routeArray = route.split('/');
    const lastRoute = routeArray[routeArray.length - 1];
    this.id = lastRoute;
    this.industry = await this.industryService.read(this.id);
  }

  update = async () => {
    let res: RestResponse<Industry>
    res = await this.industryService.update(this.id, this.dto);
    if (res.data) {
      await this.modalController.dismiss();
      await this.displayService.toast({message: 'Industry updated successfully', position: 'top'});
    }
  }

}
